module.exports = __webpack_public_path__ + "static/media/CM.c2f87b3d.png";